/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CcmAccountStatusEnum } from './ccmAccountStatusEnum';


/**
 * Specification for updating account settings
 */
export interface CloudCostMgmtAccountUpdateSpec { 
    /**
     * Enable or disable cleanup for this account
     */
    cleanup_enabled?: boolean;
    status?: CcmAccountStatusEnum;
}
export namespace CloudCostMgmtAccountUpdateSpec {
}


